module.exports = {
	Register_account: '註冊平台新帳戶',
	User_registration: '1、用戶註冊',
	regist_tip: '用戶註冊支持用戶用手機號或者郵箱註冊，註冊頁面需要填寫的信息基本相同。內容都是必填項，按要求填寫後點擊Register按鈕即可註冊成功。',
	User_login: '2、用戶登錄',
	login_tip: '已註冊用戶默認進入登錄頁面，填寫用戶名和密碼即可登錄，新用戶也可以點擊註冊 進行註冊。',
	Bind_Exchange_API: '綁定交易所API',
	bind_api_tip1: '1、進入我的頁面 > 點擊交易所API授權 > 選擇要綁定的交易所，點擊複製後到瀏覽器打開交易所註冊鏈接。',
	bind_api_tip2: '2、在瀏覽器打開的交易所創建API Key（如已創建，請忽略此步）',
	okx_api_tip: '1）Okx 創建API Key（重要參數勾選）',
	gate_api_tip: '3）Gateio創建API Key（重要參數勾選）',
	bind_api_tip3: '3、打開UPlus APP綁定使用的交易所API,輸入API生成的接口信息（可以配置查詢、交易、提現等權限）',
	binance_api_tip: '2）Binance 創建API Key（重要參數勾選）',
	binance_api_tip1: '① 點擊圖中創建api，完成安全驗證後進行下一步操作。',
	binance_api_tip2: '② 按照下圖勾出的重要參數勾選API可用權限（請注意，交易權限僅激活90天，到期後需要重新激活）。',
	binance_api_tip3: '③ 得到API Key後請先複製到其他地方保存以便後續使用，如遇密碼加密，請先刪除再重新創建。',
	okx_open_account_contract: '開通帳戶合約量化權限',
	okx_open_account_contract1: '1、打開歐易APP，點擊中間“交易”',
	okx_open_account_contract2: '2、在交易頁面點擊左上角圖標“',
	okx_open_account_contract3: '3、找到“交易設置”，點擊“交易設置”',
	okx_open_account_contract4: '4、找到“帳戶模式”點擊“帳戶模式”修改為“單幣種保證金模式”點擊“設置”即會跳轉到答題頁面',
	okx_open_account_contract5: '5、通過答題後即可升級單幣種保證金模式，即為設置成功。',
	quotation_marks: '”',
	next: '下一步',
	recharge_fuel_fee: '充值燃料費',
	recharge_fuel_fee1: '1、進入我的頁面 > 點擊總資產或者資金帳戶、交易帳戶任意位置進入我的資產詳情',
	recharge_fuel_fee2: '2、點擊充值即可跳到充值頁面,掃描二維碼進行USDT的充值',
	recharge_fuel_fee3: '3、充值完成後幣是存放在資金帳戶,需要將資金帳戶的資金劃轉到交易帳戶才可以進行交易',
	recharge_fuel_fee4: '點擊劃轉，輸入轉入數量，確定後即可完成劃轉。',
	purchase_point_card: '購買點卡',
	recharge_fuel_fee5: '1、點擊我的 > 購買點卡 或者點擊我的 > 錢包總資產頁面 > 購買',
	recharge_fuel_fee6: '2、選擇點卡套餐購買點卡。',
	start_robot: '啟動機器人',
	start_robot1: '1、點擊機器人頁面 > 開啟機器人 ，機器人處於啟動狀態即為開啟成功',
	start_robot2: '2、添加策略',
	start_robot2_1_1: '（1）設置參數',
	start_robot2_1_2: '例如：設置投入策略的USDT金額：600 USDT',
	start_robot2_2_1: '（2）策略運行',
	start_robot2_2_2: '對沖合約交易為全自動策略，無需手動干預，',
	start_robot2_2_3: '運行中可能有浮虧，為避免產生不必要的虧損，請謹慎操作',
	start_robot2_2_4: '收益將自動劃轉至交易所的資金帳戶',
	create_policy: '去創建策略',
	go_login: '去登錄',
	recharge_fuel_fee_point_card: '充值燃料費/購買點卡',
	goto_opentutorial_tip1: '如有疑問，您可以訪問',
	common_problem: '常見問題',
	goto_opentutorial_tip2: '了解更多',


}
